(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplateModule')
        .controller('oddQuestionTypeMultipleFieldsController', Controller);

    Controller.$inject = [];

    function Controller() {
        /**
         * @property {{
         *      ODDQuestionFields: [ODDQuestion]
         * }} boxModel
         * @property {{
         *      ODDQuestionID
         * }} ODDQuestion
         */

    }
})();